import React from 'react'
import { ForgotPassword } from 'syngenta-react-components'
import { loginInfo } from '../../services/authConfig'
import Logo from '../../assets/images/GrowMore360_Logo.svg'

const ForgotPasswordView = () => {
  const { REGION, USER_POOL_ID, APP_CLIENT_ID, IDENTITY_POOL_ID, COGNITO_DOMAIN, COGNITO_SIGNIN_CALLBACK, COGNITO_SIGNOUT_CALLBACK } = loginInfo
  return (
    <ForgotPassword
      containerClasses="bgc-white bd1-s-darkgray w375 pr25 pl25 mauto"
      logoPath={Logo}
      REGION={REGION}
      USER_POOL_ID={USER_POOL_ID}
      APP_CLIENT_ID={APP_CLIENT_ID}
      IDENTITY_POOL_ID={IDENTITY_POOL_ID}
      COGNITO_DOMAIN={COGNITO_DOMAIN}
      COGNITO_SIGNIN_CALLBACK={COGNITO_SIGNIN_CALLBACK}
      COGNITO_SIGNOUT_CALLBACK={COGNITO_SIGNOUT_CALLBACK}
    />
  )
} 

export default ForgotPasswordView